import { useState } from "react";

// SHA-256 hash of the password — the actual password never appears in source
const PASSWORD_HASH =
  "f14f19a3aa63f499727bb4f9a91667369eb5037e1b3ac3a1973dc019d106e174";

async function sha256(text) {
  const encoded = new TextEncoder().encode(text);
  const buffer = await crypto.subtle.digest("SHA-256", encoded);
  return Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export default function Login({ onLogin }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [shaking, setShaking] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const hash = await sha256(password);
    if (hash === PASSWORD_HASH) {
      sessionStorage.setItem("wedding-auth", "true");
      onLogin();
    } else {
      setError("Incorrect password. Please try again.");
      setShaking(true);
      setTimeout(() => setShaking(false), 500);
    }
  };

  return (
    <div className="login-bg">
      <div
        style={{
          background: "rgba(255, 255, 255, 0.95)",
          borderRadius: "16px",
          padding: "48px 40px",
          maxWidth: "420px",
          width: "90%",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
          textAlign: "center",
          animation: shaking ? "shake 0.5s ease-in-out" : "fadeInUp 0.8s ease-out",
        }}
      >
        <div style={{ marginBottom: "8px" }}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" style={{ margin: "0 auto" }}>
            <path
              d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
              fill="#1e40af"
            />
          </svg>
        </div>

        <h1 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: "2rem",
          color: "#1e40af",
          marginBottom: "4px",
        }}>
          Elijah & Diana
        </h1>

        <p style={{
          color: "#64748b",
          fontSize: "0.95rem",
          marginBottom: "32px",
        }}>
          Please enter the password to view our wedding website
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setError("");
            }}
            placeholder="Enter password"
            className="rsvp-input"
            style={{ marginBottom: "16px", textAlign: "center", letterSpacing: "2px" }}
            autoFocus
          />

          {error && (
            <p style={{
              color: "#ef4444",
              fontSize: "0.875rem",
              marginBottom: "12px",
            }}>
              {error}
            </p>
          )}

          <button type="submit" className="btn-wedding" style={{ width: "100%" }}>
            Enter
          </button>
        </form>

        <p style={{
          marginTop: "24px",
          color: "#94a3b8",
          fontSize: "0.8rem",
        }}>
          July 2nd, 2026
        </p>
      </div>

      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20% { transform: translateX(-10px); }
          40% { transform: translateX(10px); }
          60% { transform: translateX(-10px); }
          80% { transform: translateX(10px); }
        }
      `}</style>
    </div>
  );
}
